// enum for supported authentication providers
export const SupportedAuthProviders = Object.freeze({
    EMAIL: 'email',
    PHONE: 'phone',
});

export default SupportedAuthProviders;